export const mainBreadCrumb = t => [
  {value: t("COMMON:FIELD.DATA_PROCESS"), to: "/"},
  {value: t("COMMON:FIELD.MAPPING"), to: "/"},
];
